export default "__VITE_ASSET__DUKK7BL6__"